import styled, { css } from 'styled-components';

interface IDisabled {
  $disabled?: boolean;
}

const getDisabledStyles = (isDisabled?: boolean) => css`
  pointer-events: ${isDisabled ? 'none' : 'auto'};
`;

export const ParcelStepLeftContainer = styled.div<IDisabled>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  max-width: 65rem;
  width: 100%;
  ${({ $disabled }) => getDisabledStyles($disabled)}
`;

export const ParcelStepMobileContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.8rem;
  min-height: 100dvh;
  background-color: transparent;
  overflow-y: hidden;
`;

export const ParcelStepMobileCotentContainer = styled.div<IDisabled>`
  display: flex;
  flex-direction: column;
  ${({ $disabled }) => getDisabledStyles($disabled)}
  @media screen and (max-width: 650px) {
    padding: 0 1.6rem;
    gap: 0.8rem;
  }
`;
